import { render, staticRenderFns } from "./User.Menu.SelectCategory.vue?vue&type=template&id=5420ba81&scoped=true&"
import script from "./User.Menu.SelectCategory.vue?vue&type=script&lang=js&"
export * from "./User.Menu.SelectCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5420ba81",
  null
  
)

export default component.exports